import { render, staticRenderFns } from "./SafariIcon.vue?vue&type=template&id=5f872d24&scoped=true"
import script from "./SafariIcon.vue?vue&type=script&lang=js"
export * from "./SafariIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f872d24",
  null
  
)

export default component.exports